export const EXHIBITORS = `
query exhibitors(
  $tenant_id: Int!,
  $skip:  Int,
  $take:  Int,
  $orderBy: ExhibitorOrderInput,
  $filter: ExhibitorFilterInput,
  $searchText: String
){
  exhibitors(
    tenant_id:$tenant_id,
    skip: $skip,
    take: $take,
    orderBy: $orderBy,
    filter: $filter,
    searchText:$searchText
  ){
    __typename
    ...on Exhibitor {
      id
      type
      linkedin
      status
      curriculum_vitae
      photo
      company_name
      cuit
      initial_month
      referred_by
      contact_id
      intergrupal
      pay
      pay_virtual
      pay_virtual_short
      roaming
      roaming_provinces
      iva_condition
      bank
      bank_account_type
      branch_office
      branch_office_number
      account_holder
      cbu
      contact {
        id
        firstname
        lastname
        email
        secondary_email
        phone
        mobile
        province
        city
        zip_code
        address
        country
        identification
        birth_date
        gender
        exclude
        comments
        profile_picture {
          id
          url
        }
      }
      presentation_count
      survey_average_rating
      survey_recommendation_percent
    }
    ...on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const EXHIBITORS_COUNT = `
query exhibitorsCount(
  $tenant_id: Int!,
  $orderBy: ExhibitorOrderInput,
  $filter: ExhibitorFilterInput,
  $searchText: String
){
  exhibitorsCount(
    tenant_id: $tenant_id,
    orderBy: $orderBy,
    filter: $filter,
    searchText: $searchText
  ){
    __typename
    ...on Count {
      count
    }
    ...on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const GET_EXHIBITOR_CV_DOWNLOAD_LINK = `
query getExhibitorCVDownloadLink($exhibitor_id: Int!, $tenant_id: Int!) {
  getExhibitorCVDownloadLink(exhibitor_id: $exhibitor_id, tenant_id: $tenant_id)
}
`;

export const EXHIBITOR_BANK_DATA = `
query exhibitorBankData($id: Int!, $tenant_id: Int!) {
  exhibitorBankData(id: $id, tenant_id: $tenant_id) {
    __typename
    ...on Exhibitor {
      id
      company_name
      cuit
      iva_condition
      bank
      bank_account_type
      branch_office
      branch_office_number
      account_holder
      cbu
      contact {
        id
        firstname
        lastname
        email
        phone
        mobile
      }
    }
    ...on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const MY_EXHIBITOR_PROFILE = `
query myExhibitorProfile($tenant_id: Int!) {
  myExhibitorProfile(tenant_id: $tenant_id) {
    __typename
    ... on Exhibitor {
      id type status pay pay_virtual pay_virtual_short probono initial_month referred_by
      roaming roaming_provinces linkedin intergrupal curriculum_vitae photo
      company_name cuit iva_condition bank bank_account_type branch_office branch_office_number account_holder cbu
      contact { id firstname lastname email secondary_email phone mobile birth_date gender country province city address zip_code identification_type_id identification position }
    }
    ... on ResultError { status_code message message_translation_key }
  }
}`;

export const MY_EXHIBITOR_PROFILE_FILE_LINKS = `
query myExhibitorProfileFileLinks($tenant_id: Int!) {
  myExhibitorProfileFileLinks(tenant_id: $tenant_id) {
    photo
    curriculum_vitae
  }
}`;
